module.exports = __webpack_public_path__ + "media/images/admin/feather-sprite-a8e6f5f34e8db7a7443536ac1a94d92c.svg";